/**
 * Created by Administrador on 29/07/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('itineraryConnections', {
                parent: 'app',
                url: '/itineraryConnections/:id',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryConnection/itineraryConnections.html',
                        controller: 'itineraryConnectionsController',
                        controllerAs: 'vm',
                        'resolve' : {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryConnection']);
                            }],
                            itineraryConnections: ['itineraryConnectionService','$stateParams',
                                function(itineraryConnectionService,$stateParams){
                                return itineraryConnectionService.getItineraryConnections($stateParams.id,$stateParams.page,$stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('itineraryConnectionNew', {
                parent: 'app',
                url: '/itineraryConnection/:id/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryConnection/itineraryConnectionNew.html',
                        controller: 'newItineraryConnectionController',
                        controllerAs: 'vm',
                        'resolve' : {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryConnection']);
                            }],
                            'groupParameter' : ['parameterService', function(parameterService){
                                return parameterService.getParametersByGroupParameter(1)
                            }]
                        }
                    }
                }
            })
            .state('itineraryConnectionEdit', {
                parent: 'app',
                url : '/itineraryConnection/:id/:itineraryConnectionId/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views : {
                    'main@' : {
                        templateUrl : 'app/admin/flightControl/itinerary/itineraryConnection/itineraryConnectionEdit.html',
                        controller : 'editItineraryConnectionController',
                        controllerAs : 'vm',
                        resolve : {
                            'itineraryConnections' : ['itineraryConnectionService','$stateParams', function(itineraryConnectionService, $stateParams){
                                return itineraryConnectionService.getItineraryConnection($stateParams.itineraryConnectionId);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryConnection']);
                            }]
                        }
                    }
                }
            })
            .state('itineraryConnectionDelete', {
                parent: 'itineraryConnections',
                url: '/itineraryConnection/:itineraryConnectionId/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryConnection/itineraryConnectionDelete.html',
                        controller: 'deleteItineraryConnectionController',
                        controllerAs: 'vm',
                        size: 'md',
                        'resolve' : {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryConnection']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('itineraryConnections', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
